/**
 *
 * AsyncPicker
 *
 */
import { Entity } from 'types/common';
import { FieldHookConfig, useField } from 'formik';
import {
  RoomPicker,
  RoomsUrl,
} from '../pickers/AutocompletePickers/RoomPicker';
import { IFieldProps } from './FormRender/IFormFieldSetting';
import { IRoomDto } from 'api/odata/generated/entities/IRoomDto';

export const FormRoomPicker = ({
  label,
  ...props
}: FieldHookConfig<Entity<number> | null> &
  IFieldProps & { variant?: 'standard' | 'filled' | 'outlined' } & {
    urlType?: RoomsUrl;
    withoutServiceGroups?: boolean;
  }) => {
  const [field, meta, helpers] = useField<Entity<number> | null>(props);
  return (
    <>
      <RoomPicker
        name={props.name}
        placeholder={props.placeholder}
        label={label}
        onChange={value => helpers.setValue(value, true)}
        onBlur={field?.onBlur}
        value={field.value as IRoomDto}
        error={meta?.error !== undefined}
        helperText={meta.error}
        disabled={props.disabled}
        fullWidth={props.fullWidth}
        info={props.info}
        variant={props.variant}
        urlType={props.urlType}
        withoutServiceGroups={props.withoutServiceGroups}
      />
    </>
  );
};
